import type React from "react"
import { useLocation } from "react-router-dom"
import { LanguageSwitcher } from "./language-switcher"

const PUBLIC_HEADER_ROUTES = new Set(["/", "/auth"])

export const GlobalHeader: React.FC = () => {
	const location = useLocation()
	if (!PUBLIC_HEADER_ROUTES.has(location.pathname)) {
		return null
	}

	return (
		<div className="fixed top-0 left-0 right-0 h-20 flex items-center justify-end px-8 z-50 pointer-events-none">
			<div className="pointer-events-auto">
				<LanguageSwitcher />
			</div>
		</div>
	)
}
